export const SUCCESS_STORIES = [
  {
    name: 'Simran on Ketto',
    description: `Simran raised ₹ 14,30,929 10X faster due to Ketto's monthly SIP program`,
    disease: 'Covid Survivor',
    img: '/assets/images/stories/success/story-1.png'
  },
  {
    name: 'Harsha on Ketto',
    description: `Harsha's life was saved due to generous contributions of ₹28,06,455 with the help of SIP`,
    disease: 'Cancer Survivor',
    img: '/assets/images/stories/success/story-2.png'
  },
  {
    name: 'Divyansh on Ketto',
    description: `Divyansh had a successful liver transplant with the help of heroes like you who contributed ₹16,77,190`,
    disease: 'Transplant Survivor',
    img: '/assets/images/stories/success/story-3.png'
  }
];
